import React, { Component } from 'react'
import Topbar from './topbar/Topbar'
import Sidebar from './sidebar/Sidebar'
import TourSidebar from '../../components/tour/dashboard/sidebar/TourSidebar'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withApollo } from 'react-apollo';
class Layout extends Component {
  render () {
    return (
       this.props.toggleTour.toggleOn ? (
        <div>
          <Topbar/>
          <TourSidebar/>
        </div>
        ) : (
         <div>
           <Topbar/>
           <Sidebar/>
         </div>
        )
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    sidebar: state.sidebar,
    toggleTour: state.toggleTour,
    cartItems: state.cartData.items
  }
}

export default withRouter(withApollo(connect(mapStateToProps, null)(Layout)));



// WEBPACK FOOTER //
// ./src/pages/_layout/Layout.js